import React, {Component} from 'react';
import {parsers} from '@neosvoc/nv-platform-core-common';
import {connect} from 'formik';
import MapWrapper from '../../maps/MapWrapper';
import GoogleMaps from '../../maps/GoogleMaps';
import {constants} from '@neosvoc/nv-platform-core-common';
import MarkerTracker from '../../maps/MarkerTracker';

class GeoType extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.validate = this.validate.bind(this);
    }

    validate(value) {
        try {
            parsers[constants.CONTENT_TYPES.GEO](value, this.props);
        } catch (err) {
            return err.payload;
        }
    }

    handleChange(pos) {
        const {formik, id} = this.props;
        formik.setFieldValue(id, pos);
    }

    render() {
        return (
            <MapWrapper>
                <GoogleMaps options={{center: {lat: 41.871940, lng: 12.567380}, zoom: 6}}>
                    <MarkerTracker onChange={this.handleChange} />
                </GoogleMaps>
            </MapWrapper>
        );
    }
}

export default connect(GeoType);
